<div class="partnersWrap">
    <div class="maxContainerWidth">
        <div class="title">
            <h3>Our Partners</h3>
        </div>
        <div class="sliderflex">
            <div class="sliderWrap">
                <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">

                    <div ngxSlickItem class="slide" *ngFor="let partner of partnersLogo">
                        <div class="imgWrap">
                            <img src="assets/images/Cod/{{partner?.image}}" alt="">
                        </div>
                    </div>

                </ngx-slick-carousel>

            </div>
            <div class="border1"></div>
            <div class="border2"></div>
            <div class="border3"></div>
        </div>

    </div>
</div>